import { createPushModal } from "pushmodal";
import { ApplyModal } from "./apply";
import { FreeToolsSignupModal } from "./free-tools-signup-modal";
import { SignupModal } from "./signup-modal";

export const { pushModal, popModal, popAllModals, replaceWithModal, useOnPushModal, onPushModal, ModalProvider } = createPushModal({
  modals: {
    signup: SignupModal,
    freeToolsSignup: FreeToolsSignupModal,
    apply: ApplyModal,
  },
});
